'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { useReveal, ShowcaseIcon } from './scene-primitives';
import { Fd } from './buyer-package';
import { MarketImage } from './market-primitives';
import { BlurSwap } from './playback-controls';
import { Vl, Bl, zl } from './collection-animation';
import { IMAI_EASE_CSS } from '@/lib/motion/imai-motion';
export function MarketStepRail({ seq: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let [t, n] = useReveal({
      once: !0,
    }),
    r = Fd.map((e, t) => ({
      step: e,
      index: t,
    })).filter(({ step: t }) => t.part === e.part);
  return (
    <div
      ref={t}
      role={'group'}
      aria-label={translateShowcaseNode(
        showcaseCopy,
        e.part === 'sell' ? 'Sell steps' : 'Market steps'
      )}
      data-in={n === null ? void 0 : String(n)}
      className={'relative flex w-full items-center'}
    >
      {translateShowcaseNode(
        showcaseCopy,
        r.map(({ step: t, index: n }, r) => {
          let i = n === e.index,
            a = n < e.index,
            o =
              n <= e.index
                ? 1
                : n === e.index + 1 && e.auto && !e.reduced
                  ? e.progress
                  : 0;
          return (
            <React.Fragment key={t.key}>
              {translateShowcaseNode(
                showcaseCopy,
                r > 0 ? (
                  <span
                    aria-hidden={!0}
                    className={
                      'relative mx-[3px] h-px min-w-1.5 flex-1 bg-[var(--border)] sm:mx-1 sm:min-w-3'
                    }
                  >
                    <span
                      className={
                        'absolute inset-0 origin-left bg-[var(--primary)]'
                      }
                      style={{
                        transform: `scaleX(${o})`,
                        transition:
                          o === 0 || o === 1
                            ? 'transform 500ms var(--ease)'
                            : 'none',
                      }}
                    />
                  </span>
                ) : null
              )}
              <button
                type={'button'}
                aria-pressed={i}
                aria-label={translateShowcaseNode(showcaseCopy, t.label)}
                onClick={() => e.select(n)}
                className={`ghost press flex h-10 shrink-0 items-center gap-2 px-0.5 text-[13px] sm:px-2 ${i ? '!text-ink font-medium' : ''}`}
              >
                <span
                  className={`grid size-8 shrink-0 place-items-center rounded-full transition-[background-color,color,box-shadow] duration-200 sm:size-7 ${i ? 'bg-[var(--primary)] text-[var(--primary-foreground)]' : a ? 'text-ink bg-[var(--state-wash)]' : 'text-ink-3 shadow-[inset_0_0_0_1px_var(--border)]'}`}
                >
                  <ShowcaseIcon
                    name={t.icon}
                    draw={'in-view'}
                    className={'size-4'}
                    style={{
                      '--i': String(r * 2),
                    }}
                  />
                </span>
                <span
                  aria-hidden={!0}
                  className={i ? 'max-sm:hidden' : 'max-lg:hidden'}
                >
                  {translateShowcaseNode(showcaseCopy, t.label)}
                </span>
              </button>
            </React.Fragment>
          );
        })
      )}
    </div>
  );
}
export function MarketPlaybackControls({ seq: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  return (
    <div className={'flex items-center gap-1'}>
      <span
        aria-hidden={!0}
        className={
          'mr-2 hidden h-[2px] w-16 overflow-hidden rounded-full bg-[var(--state-wash)] sm:block'
        }
      >
        <span
          className={'block h-full origin-left bg-[var(--primary)]'}
          style={{
            transform: `scaleX(${e.progress})`,
          }}
        />
      </span>
      <button
        type={'button'}
        onClick={e.togglePause}
        disabled={e.reduced || e.progress >= 1}
        aria-label={translateShowcaseNode(
          showcaseCopy,
          e.paused ? 'Play' : 'Pause'
        )}
        className={
          'ghost press grid size-10 place-items-center disabled:opacity-40 sm:size-8'
        }
      >
        <ShowcaseIcon name={e.paused ? 'play' : 'pause'} className={'size-4'} />
      </button>
      <button
        type={'button'}
        onClick={e.replay}
        className={
          'ghost press flex h-10 items-center gap-1.5 px-2.5 text-[13px] font-medium sm:h-8'
        }
      >
        <ShowcaseIcon name={'replay'} className={'size-4'} />
        {translateShowcaseNode(showcaseCopy, 'Replay')}
      </button>
    </div>
  );
}
export const zd = IMAI_EASE_CSS;
export function useMarketTileAnimation(e, t) {
  let n = React.useRef(null),
    r = React.useRef(new Map());
  return (
    React.useLayoutEffect(() => {
      let e = n.current;
      if (!e) return;
      let i = new Map(),
        a = 0;
      (e.querySelectorAll('[data-flip]').forEach((e) => {
        let n = e.dataset.flip;
        if (!n) return;
        let o = {
          x: e.offsetLeft,
          y: e.offsetTop,
          w: e.offsetWidth,
          h: e.offsetHeight,
        };
        if ((i.set(n, o), t)) return;
        let s = r.current.get(n);
        if (!s) {
          e.animate(
            [
              {
                opacity: 0,
                transform: 'scale(0.94)',
                filter: 'blur(4px)',
              },
              {
                opacity: 1,
                transform: 'none',
                filter: 'blur(0px)',
              },
            ],
            {
              duration: 420,
              easing: zd,
              delay: a++ * 50,
              fill: 'backwards',
            }
          );
          return;
        }
        let c = s.x - o.x,
          l = s.y - o.y,
          u = s.w !== o.w || s.h !== o.h;
        (c || l || u) &&
          e.animate(
            [
              {
                transform: `translate(${c}px, ${l}px)`,
                ...(u
                  ? {
                      opacity: 0.35,
                      filter: 'blur(3px)',
                    }
                  : {}),
              },
              {
                transform: 'none',
                opacity: 1,
                filter: 'blur(0px)',
              },
            ],
            {
              duration: 560,
              easing: zd,
            }
          );
      }),
        (r.current = i));
    }, [e, t]),
    n
  );
}
export const Vd = {
  strip: 380,
  tabs: 900,
  tiles: 1100,
  flagship: 3500,
  wholesale: 5900,
  done: 6500,
};
export function channelProducts(e) {
  return e >= Vd.wholesale
    ? 'wholesale'
    : e >= Vd.flagship
      ? 'flagship'
      : 'online';
}
export function ChannelTile({ piece: e, channel: t, hero: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let r = t.tag(e, n),
    i = t.prices === 'wholesale';
  return (
    <figure
      data-flip={e.id}
      className={`m-0 flex min-w-0 flex-col gap-1.5 ${n ? 'mk-tile-hero' : ''}`}
    >
      <span className={`relative block min-h-0 ${n ? 'flex-1' : ''}`}>
        <MarketImage
          asset={e.asset}
          alt={translateShowcaseNode(showcaseCopy, `${e.title}: ${e.name}`)}
          className={`rounded-[10px] bg-[var(--muted)] ${n ? 'absolute! inset-0' : 'aspect-[3/4]'}`}
        />
        {translateShowcaseNode(
          showcaseCopy,
          r ? (
            <span
              className={
                'pop text-ink absolute top-1.5 left-1.5 rounded-full px-2 py-0.5 text-[11px] leading-4 font-medium'
              }
            >
              <BlurSwap value={r} />
            </span>
          ) : null
        )}
      </span>
      <figcaption
        className={'flex min-w-0 flex-col px-0.5 text-[12px] leading-4'}
      >
        <span className={'text-ink truncate font-medium'}>
          {translateShowcaseNode(showcaseCopy, e.title)}
        </span>
        <span className={'num text-ink-3 truncate'}>
          <BlurSwap value={Vl(i ? e.wholesale : e.retail)} />
          {translateShowcaseNode(
            showcaseCopy,
            i ? (
              <span className={'text-ink-4 max-sm:hidden'}>
                {translateShowcaseNode(showcaseCopy, ' ')}
                {translateShowcaseNode(showcaseCopy, '\xB7 MSRP ')}
                {translateShowcaseNode(showcaseCopy, Vl(e.retail))}
              </span>
            ) : null
          )}
        </span>
      </figcaption>
    </figure>
  );
}
export function ChannelSummary({ channel: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let t = Bl(e.ids[0] ?? 'topcoat'),
    n = [
      {
        label: 'Styles',
        value: `${e.ids.length} of ${zl.length}`,
      },
      {
        label: 'Prices',
        value: e.prices === 'retail' ? 'Retail' : 'Wholesale',
      },
      {
        label: 'Lead style',
        value: t?.title ?? '',
      },
    ];
  return (
    <dl
      className={
        'grid grid-cols-[auto_auto_minmax(0,1fr)] gap-x-5 gap-y-3 lg:grid-cols-1'
      }
    >
      {translateShowcaseNode(
        showcaseCopy,
        n.map((e) => (
          <div key={e.label} className={'min-w-0'}>
            <dt className={'label'}>
              {translateShowcaseNode(showcaseCopy, e.label)}
            </dt>
            <dd
              className={
                'num text-ink mt-0.5 truncate text-[14px] leading-5 font-medium'
              }
            >
              <BlurSwap value={e.value} />
            </dd>
          </div>
        ))
      )}
      <p
        className={
          'text-ink-3 col-span-3 text-[13px] leading-5 lg:col-span-1 lg:mt-1'
        }
      >
        <BlurSwap value={e.note} />
      </p>
    </dl>
  );
}
